import { useMutation } from "@tanstack/react-query";
import { confirmPhoneCode } from "@/http/userApi";

interface ConfirmPhoneCodeData {
  phone: string;
  code: string;
}

export const useConfirmPhoneCodeMutation = () => {
  return useMutation({
    mutationFn: async (data: ConfirmPhoneCodeData) => {
      return await confirmPhoneCode(data.phone, data.code);
    },
  });
};
